export const ROOM_UNSPECIFIED = '指定なし'
